/**
 * @module app.prospection.store.disposalCtrl
 */

define(['angular', 'moment'], function(angular, moment) {


    function DisposalCtrl($scope, $rootScope, $log, $window, disposalService, editionService, Notification) {
        let self = this;
        let store = JSON.parse(JSON.stringify($scope.storeCtrl.store));
        self.error = {};
        self.LEA = _getContract('LEA');
        self.TPE = _getContract('TPE');
        self.MAI = _getContract('MAI');
        self.successeur = {
            sexeClient: null,
            nom: null,
            prenom: null,
            adresse: null,
            codePostal: null,
            ville: null,
            email: null,
            telephonePortable: null,
            iban: null,
            bic: null,
            rsc: null,
            raisonSociale: store.raison_sociale
        }
        self.predecesseur = {
            sexeClient: store.customers[0].sexe_client,
            nom: store.customers[0].nom_client,
            prenom: store.customers[0].prenom_client,
            nim: store.code_nim_magasin,
            pdv: store.identifiant_magasin_x3,
            financement: null,
            typeCaisse: null,
            nbCaisse: null,
            maintenance: null,
            isMudetaf: false,
            mudetaf: null,
            dateReprise: null
        };
        self.store = {
            disposalId: null,
            enseigne: store.enseigne,
            raisonSociale: store.raison_sociale,
            adresse: store.contact.adresse,
            codePostal: store.contact.code_postal,
            ville: store.contact.ville,
            telephone: store.contact.telephone_fixe,
            interlocuteur: null,
            dateEcritInfoReprise: null,
            source: null,
            dateEnvoi : null,
            typeEnvoi: null,
            leaser: self.LEA.length > 0 ? $scope.storeCtrl.leaser[self.LEA[0].leaser] : null,
            montantLeasing: null,
            nbTpe : null,
            montantTpe: null,
        };

        self.financementList = disposalService.financementList;
        self.leaser = disposalService.leaser;
        self.typesCaisse = disposalService.typesCaisse;
        self.nbCaisse = disposalService.nbCaisse;
        self.interlocuteurs = disposalService.interlocuteurs;
        self.sources = disposalService.sources;

        function _getContract(type){
            return store.contracts ? store.contracts.reduce((curr, contract) => {
                if(contract.type_contrat === type && moment(contract.date_fin_validite).isAfter(moment()))
                    curr.push(contract);
                return curr;
            }, []) : [];
        }

        self.toggleMudetaf = () => {
            self.predecesseur.isMudetaf = !self.predecesseur.isMudetaf;
            self.predecesseur.mudetaf = self.predecesseur.isMudetaf ? self.predecesseur.mudetaf : null;
        }

        self.changeFinancement = () => {
            if(self.predecesseur.financement === 'Achat'){
                self.store.leaser = null;
                self.store.montantLeasing = null;
            }
        }

        self.getDisposals = () => {
            disposalService.getDisposals(store.identifiant_magasin).then(disposal => {
                if(disposal.length > 0){
                    self.store.disposalId = disposal[0].disposal_id;
                    self.successeur.sexeClient = disposal[0].successor_civility;
                    self.successeur.nom = disposal[0].successor_lastname;
                    self.successeur.prenom = disposal[0].successor_firstname;
                    self.successeur.adresse = disposal[0].successor_address_street;
                    self.successeur.codePostal = disposal[0].successor_address_postal_code;
                    self.successeur.ville = disposal[0].successor_address_city;
                    self.successeur.email = disposal[0].successor_email;
                    self.successeur.telephonePortable = disposal[0].successor_phone;
                    self.successeur.iban = disposal[0].successor_iban;
                    self.successeur.bic = disposal[0].successor_bic;
                    self.successeur.rcs = disposal[0].successor_rcs;
                    self.successeur.raisonSociale = disposal[0].successor_corporate_name;
                    self.predecesseur.financement = disposal[0].funding;
                    self.predecesseur.typeCaisse = disposal[0].cash_register_type;
                    self.predecesseur.nbCaisse = disposal[0].cash_register_number;
                    self.predecesseur.maintenance = disposal[0].maintenance_amount;
                    self.predecesseur.isMudetaf = disposal[0].isMudetaf;
                    self.predecesseur.mudetaf = disposal[0].mudetaf_amount;
                    self.predecesseur.dateFinContrat = disposal[0].end_date_contract ? new Date(disposal[0].end_date_contract) : new Date(self.LEA[0].date_fin_validite);
                    self.predecesseur.dateReprise = disposal[0].succession_date ? new Date(disposal[0].succession_date) : null;
                    self.store.interlocuteur = disposal[0].interlocutor;
                    self.store.dateEcritInfoReprise = disposal[0].date_write ? new Date(disposal[0].date_write) : null;
                    self.store.source = disposal[0].write_type;
                    self.store.dateEnvoi = disposal[0].date_send ? new Date(disposal[0].date_send) : null;
                    self.store.typeEnvoi = disposal[0].send_type;
                    self.store.leaser = disposal[0].leaser;
                    self.store.montantLeasing = disposal[0].leasing_amount;
                    self.store.nbTpe = disposal[0].tpe_number;
                    self.store.montantTpe = disposal[0].tpe_amount;
                    // self.dateFinContrat = disposal[0].end_date_contract ? new Date(disposal[0].end_date_contract) : new Date(self.LEA[0].date_fin_validite);
                    // self.dateEcrit = disposal[0].date_write ? new Date(disposal[0].date_write) : null;
                    // self.dateReprise = disposal[0].succession_date ? new Date(disposal[0].succession_date) : null;
                    // self.dateEnvoie = disposal[0].date_send ? new Date(disposal[0].date_send) : null;
                }
            });
        }

        self.getDisposals();

        self.saveDisposal = () => {
            let disposal = {
                disposalId: self.store.disposalId,
                predecessorStoreId: store.identifiant_magasin,
                successorCivility: self.successeur.sexeClient,
                successorLastname: self.successeur.nom,
                successorFirstname: self.successeur.prenom,
                successorAddressStreet: self.successeur.adresse,
                successorAddressPostalCode: self.successeur.codePostal,
                successorAddressCity: self.successeur.ville,
                successorEmail: self.successeur.email,
                successorPhone: self.successeur.telephonePortable,
                successorIban: self.successeur.iban,
                successorBic: self.successeur.bic,
                successorRcs: self.successeur.rcs,
                successorCorporateName: self.successeur.raisonSociale,
                successionDate: self.predecesseur.dateReprise ? moment(self.predecesseur.dateReprise).format('YYYY-MM-DD') : null,
                funding: self.predecesseur.financement,
                cashRegisterType: self.predecesseur.typeCaisse,
                cashRegisterNumber: self.predecesseur.nbCaisse,
                maintenanceAmount: isNaN(parseFloat(self.predecesseur.maintenance)) ? null : self.predecesseur.maintenance,
                isMudetaf: self.predecesseur.isMudetaf === null ? false : self.predecesseur.isMudetaf,
                mudetafAmount: isNaN(parseFloat(self.predecesseur.mudeta)) ? null : self.predecesseur.mudetaf,
                interlocutor: self.store.interlocuteur,
                dateWrite: self.store.dateEcritInfoReprise ? moment(self.store.dateEcritInfoReprise).format('YYYY-MM-DD') : null,
                writeType: self.store.source,
                dateSend: self.store.dateEnvoi ? moment(self.store.dateEnvoi).format('YYYY-MM-DD') : null,
                sendType: self.store.typeEnvoi,
                endDateContract: self.predecesseur.dateFinContrat ? moment(self.predecesseur.dateFinContrat).format('YYYY-MM-DD') : null,
                leaser: self.store.leaser,
                leasingAmount: isNaN(parseFloat(self.store.montantLeasing)) ? null : self.store.montantLeasing,
                tpeNumber: self.store.nbTpe,
                tpeAmount: isNaN(parseFloat(self.store.montantTpe)) ? null : self.store.montantTpe,
                status: 'En cours'
            }
            disposalService.saveDisposal(disposal).then(res => {
                self.store.disposalId = res.disposal_id;
                Notification.success('Sauvegarde effectuée avec succès.')
            }).catch(function(err) {
                Notification.error(err);
            })
        }

        self.getDocuments = function() {
            editionService.getAllPartners('client').then(partners => {
                editionService.getDocumentsByPartner(partners[0].id)
                    .then(function(documents) {
                        documents.forEach(doc => {
                            if(doc.templateXsl === 'courrier_mudetaf'){
                                if(self.predecesseur.isMudetaf)
                                    $window.open(`
                                        ${editionService.url}edition/disposal/${self.store.disposalId}/template/${doc.templateXsl}`
                                    );
                            } else {
                                $window.open(`
                                ${editionService.url}edition/disposal/${self.store.disposalId}/template/${doc.templateXsl}`
                                );
                            }

                        });
                        if(self.predecesseur.financement !== 'Renouvellement') {
                            $window.open(`
                                    ${editionService.url}edition/disposal/${self.store.disposalId}/sepa/BURALOG`
                            );
                            $window.open(`
                                    ${editionService.url}edition/disposal/${self.store.disposalId}/sepa/SRD`
                            );
                            $window.open(`
                                    ${editionService.url}edition/disposal/${self.store.disposalId}/sepa/SRDMP`
                            );
                        }
                    })
            }).catch(function(err) {
                $log.error(err);
                Notification.error('Une erreur est survenue : ' + err.data);
            });
        }

        return self;
    }

    DisposalCtrl.$inject = ['$scope', '$rootScope', '$log', '$window', 'disposalService', 'editionService', 'Notification'];

    angular.module('app.prospection.store.disposalCtrl', []).controller('DisposalCtrl', DisposalCtrl);
});
